import SoftBox from "components/SoftBox";

import CompanyInfo from "layouts/pages/account/company/components/Overview/components/CompanyInfo";

function Overview({ isEditing, setIsEditing }) {
  return (
    <SoftBox>
      <CompanyInfo isEditing={isEditing} setIsEditing={setIsEditing} />
    </SoftBox>
  );
}

export default Overview;
